/**
 * mc-header.js — Manifesto
 *
 * Comportamento do header-manifesto.liquid:
 *   1. Drawer mobile — hamburger abre; lupa abre E foca o campo de busca
 *      (paridade com o Header.tsx do React, onde a lupa abre o drawer com a
 *      busca focada); backdrop / X / Escape / mudança de rota fecham.
 *   2. Blur no scroll — adiciona `.is-scrolled` em <mc-header> após 8px.
 *   3. Body scroll lock enquanto o drawer está aberto.
 *   4. Dropdowns desktop (hover + clique + Escape + click-out).
 *   5. Submenus colapsáveis no drawer mobile.
 *
 * A busca em si (autocomplete, debounce, teclado) é do <predictive-search> do
 * Dawn (predictive-search.js + search-form.js). Aqui só abrimos/focamos.
 */

(function () {
  'use strict';

  function init() {
    var header = document.querySelector('mc-header');
    var mobile = document.querySelector('[data-mc-mobile]');

    // ── Scroll blur ──
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // ── Drawer mobile ──
    if (mobile) {
      var openers = document.querySelectorAll('[data-mc-menu-open]');
      var searchOpeners = document.querySelectorAll('[data-mc-search-open]');
      var closers = mobile.querySelectorAll('[data-mc-menu-close]');

      var openDrawer = function (focusSearch) {
        mobile.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        document.querySelectorAll('[data-mc-menu-open],[data-mc-search-open]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'true');
        });
        if (focusSearch) {
          var input = mobile.querySelector('#mc-search-mobile');
          if (input) setTimeout(function () { input.focus(); }, 120);
        }
      };
      var closeDrawer = function () {
        mobile.classList.remove('is-open');
        document.body.style.overflow = '';
        document.querySelectorAll('[data-mc-menu-open],[data-mc-search-open]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      };

      openers.forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
      searchOpeners.forEach(function (b) { b.addEventListener('click', function () { openDrawer(true); }); });
      closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobile.classList.contains('is-open')) closeDrawer();
      });

      // Submenus colapsáveis
      mobile.querySelectorAll('[data-mc-collapse-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var group = trigger.closest('[data-mc-collapsible]');
          var body = group && group.querySelector('[data-mc-collapse-body]');
          if (!group || !body) return;
          var isOpen = group.hasAttribute('data-open');
          if (isOpen) {
            group.removeAttribute('data-open');
            body.setAttribute('hidden', '');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            group.setAttribute('data-open', '');
            body.removeAttribute('hidden');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    // ── Contagem do carrinho no drawer mobile (· N) ──
    // Renderizada server-side com cart.item_count; mantida em sincronia com os
    // adds AJAX via o mesmo evento pub/sub 'cart-update'.
    var setMobileCartCount = function (qty) {
      document.querySelectorAll('[data-mc-mobile-cart-count]').forEach(function (el) {
        el.textContent = '· ' + qty;
        el.classList.toggle('is-empty', qty === 0);
      });
    };
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function (event) {
        if (event && event.cartData && typeof event.cartData.item_count === 'number') {
          setMobileCartCount(event.cartData.item_count);
          return;
        }
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) { if (data) setMobileCartCount(data.item_count || 0); })
          .catch(function () {});
      });
    }

    // ── Dropdowns desktop ──
    document.querySelectorAll('[data-mc-dropdown]').forEach(function (group) {
      var trigger = group.querySelector('[data-mc-dropdown-trigger]');
      var closeTimer = null;
      var open = function () {
        if (closeTimer) clearTimeout(closeTimer);
        group.setAttribute('data-open', '');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      };
      var close = function () {
        group.removeAttribute('data-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      };
      group.addEventListener('mouseenter', open);
      group.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(close, 120);
      });
      if (trigger) {
        trigger.addEventListener('click', function () {
          group.hasAttribute('data-open') ? close() : open();
        });
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.addEventListener('click', function (e) {
        if (!group.contains(e.target)) close();
      });
    });

    // ── Mega menus ("Cervejas" 0017 + "Países" 0021) ──
    // CSS hover keeps working without JS; here we add click-toggle,
    // keyboard (Escape returns focus), focusout-close and click-out-close.
    // .js-mega disables the CSS :focus-within fallback so JS owns the state.
    //
    // DP-7 (0021) — ONE panel open at a time. Each group used to know only
    // itself (own mouseleave + own click-out), so panel A opened by CLICK stayed
    // open when the pointer went straight to trigger B: A never got mouseleave
    // and its click-out never fired on mouseenter => two panels open. The shared
    // registry below closes the others synchronously from openMega().
    //
    // Document listeners are registered ONCE for all groups (they used to be
    // per group — with 2 megas that meant 4 duplicated document listeners).
    var megaGroups = [];

    var closeOtherMegas = function (except) {
      megaGroups.forEach(function (entry) {
        if (entry.group !== except) entry.close();
      });
    };

    document.querySelectorAll('[data-mc-mega]').forEach(function (group) {
      group.classList.add('js-mega');
      var trigger = group.querySelector('[data-mc-mega-trigger]');
      var megaCloseTimer = null;
      var closeMega = function () {
        group.removeAttribute('data-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      };
      var openMega = function () {
        if (megaCloseTimer) clearTimeout(megaCloseTimer);
        // Synchronous exclusion (AJ-7): the other panel closes in the SAME tick,
        // before any transition — both transitions then run concurrently, so
        // there is no crossfade and no "close, wait, open" background flash.
        // We deliberately do NOT clear the other group's pending 120ms timer:
        // it would only fire a no-op close on an already closed panel.
        closeOtherMegas(group);
        group.setAttribute('data-open', '');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      };
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (finePointer.matches) {
        group.addEventListener('mouseenter', openMega);
        group.addEventListener('mouseleave', function () {
          // 120ms anti-flicker timer preserved (AJ-7): crossing the 2px gap
          // between the two triggers, B's mouseenter closes A immediately and
          // this pending close lands on an already closed panel.
          megaCloseTimer = setTimeout(closeMega, 120);
        });
      }
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          // Without JS this <a> navigates to the "view all" collection;
          // with JS it toggles the panel (the panel has the same link).
          e.preventDefault();
          group.hasAttribute('data-open') ? closeMega() : openMega();
        });
      }
      group.addEventListener('focusout', function (e) {
        if (!group.contains(e.relatedTarget)) closeMega();
      });
      megaGroups.push({ group: group, trigger: trigger, close: closeMega });
    });

    if (megaGroups.length) {
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        megaGroups.forEach(function (entry) {
          if (!entry.group.hasAttribute('data-open')) return;
          var focusWasInside = entry.group.contains(document.activeElement);
          entry.close();
          if (entry.trigger && focusWasInside) entry.trigger.focus();
        });
      });
      document.addEventListener('click', function (e) {
        megaGroups.forEach(function (entry) {
          if (!entry.group.contains(e.target)) entry.close();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
